export { default as config } from "./config";
export * from "./clipboard";
export * from "./date";
export * from "./split-flight-identifier";
export * from "./is-valid-email";
export { default as openBoxFolderForCurrentClaim } from "./open-box-folder";

export function minTwoDigits(n: number) {
  return (n < 10 ? '0' : '') + n;
}

/**
 * @param {number} civilityCode - The "ISO/IEC 5218" civility code
 * @link {see: https://en.wikipedia.org/wiki/ISO/IEC_5218}
 */
export function getCivilityTitle(civilityCode: number) : string {
  if (civilityCode === 1) return "Mr."
  else if (civilityCode === 2) return "Mde."
  return ""
}

export function extractUUIDsFromString(input: string): string[] {
  const uuidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
  const matches = input.match(uuidRegex);
  return matches || [];
}

export function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};